import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";
import GrowYourBusiness from "./components/GrowYourBusiness";
import WorkSmarter from "./components/WorkSmarter";

import styles from "./styles.module.scss";

const Heading: FC = () => (
  <Content
    containerClassName={styles.wrapper}
    contentClassName={styles.container}
  >
    <Label className={styles.title} color="primary" variant="h2-centered">
      Getting new customers has never been this easy
    </Label>
    <Label className={styles.subtitle} color="primary" variant="s2-centered">
      Fast payment, immediate approvals, and a guarantee of consistent, steady
      jobs.
    </Label>
    <div className={styles.section}>
      <WorkSmarter />
    </div>
    <div className={styles.section}>
      <GrowYourBusiness />
    </div>
  </Content>
);

export default Heading;
